// @core/api/endpoints/webhook/rotate_secret.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RotateSecretRequest,
  RotateSecretResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Rotate webhook secret
 * Generates a new signing secret for the webhook endpoint. The new secret is returned once and must be updated in your receiving application.
 */
export async function RotateSecret(
  endpoint_id: string,
  data: RotateSecretRequest,
  options?: RequestOptions
): Promise<RotateSecretResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/rotate-secret`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.post<RotateSecretResponse>(requestPath, data, requestOptions);
}
